import React from "react";
import { useOnboardingHook } from "./onboarding-hooks";

type ContextOnboarding = ReturnType<typeof useOnboardingHook>;
export const OnboardingContext = React.createContext<ContextOnboarding | null>(
  null,
);

export function useContextOnboarding() {
  const context = React.useContext(OnboardingContext);

  if (!context) {
    throw new Error(
      "useContextOnboarding must be used within a ContextOnboardingProvider",
    );
  }

  return context;
}
